"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const merge_1 = __importDefault(require("lodash/merge"));
const react_1 = require("react");
const Yup = __importStar(require("yup"));
const PredictionManager_1 = require("../../../data/PredictionManager");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const Label_1 = __importDefault(require("../../elements/Label"));
const FormikOnChange_1 = __importDefault(require("../../elements/formik/FormikOnChange"));
const FormikSelect_1 = __importDefault(require("../../elements/formik/FormikSelect"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const FormikInput_1 = __importDefault(require("../../elements/formik/FormikInput"));
const predictionFormValidation = Yup.object().shape({
    '1d': Yup.object({
        lineWidth: Yup.number().integer().min(1).required(),
    }),
});
const labelStyle = {
    label: { fontSize: '10px' },
    wrapper: { display: 'flex', alignItems: 'center', height: '100%' },
    container: { padding: '0 5px', height: '100%' },
};
const selectStyles = { width: '100%', minWidth: '75px', fontSize: '10px' };
function PredictionSimpleOptions() {
    const { dispatch } = (0, PreferencesContext_1.usePreferences)();
    const predictionPreferences = (0, usePanelPreferences_1.usePanelPreferences)('prediction');
    const optionsChangeHandler = (0, react_1.useCallback)((values) => {
        const value = (0, merge_1.default)({}, (0, PredictionManager_1.getDefaultPredictionOptions)(), values);
        dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'prediction', value },
        });
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: predictionPreferences, validationSchema: predictionFormValidation, enableReinitialize: true, 
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit: () => { }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                display: 'flex',
                justifyContent: 'flex-end',
                flex: '1',
                height: '100%',
            }, children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "Frequency", style: labelStyle, children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { items: PredictionManager_1.FREQUENCIES, style: selectStyles, name: "frequency" }) }), (0, jsx_runtime_1.jsxs)(Label_1.default, { title: "Line Width", style: labelStyle, children: [(0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "1d.lineWidth", type: "number", style: { input: { width: '40px', textAlign: 'center' } } }), (0, jsx_runtime_1.jsx)("span", { style: { padding: '0 5px' }, children: "Hz" })] }), (0, jsx_runtime_1.jsx)(FormikOnChange_1.default, { enableValidation: true, onChange: optionsChangeHandler })] }) }));
}
exports.default = PredictionSimpleOptions;
